module.exports = __webpack_public_path__ + "static/media/Morgan-logo-640x178.7c2b5911.jpg";